import { Box, Container, Typography } from '@mui/material';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from './components/Footer';
import Header from './components/Header';
import PreFooterLinks from './components/PreFooterLinks';
import RateLookupTool from './components/RateLookupTool';
import SplashPage from './components/SplashPage';
import './assets/fonts/fonts.css';

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [resetTrigger, setResetTrigger] = useState(0);

  const handleGetStarted = () => {
    setShowSplash(false);
  };

  const handleStartOver = () => {
    setShowSplash(true);
    setResetTrigger((prev) => prev + 1);
  };

  return (
    <>
      <Helmet>
        <title>AGILE Rates Centre | Allianz Retire Plus</title>
        <meta name="description" content="Calculate lifetime income rates for AGILE products" />
      </Helmet>

      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        {/* Header */}
        <Header onStartOver={handleStartOver} />

        {/* Main Content */}
        <Box sx={{ flex: 1 }}>
          {showSplash ? (
            <SplashPage onGetStarted={handleGetStarted} />
          ) : (
            <Container maxWidth="lg" sx={{ py: 4 }}>
              {/* Descriptive Copy */}
              <Box sx={{ mb: 4, textAlign: 'center' }}>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ maxWidth: '800px', mx: 'auto' }}
                >
                  The AGILE Rates Centre supports existing and prospective AGILE investors to understand what Lifetime Income Rate may be applicable to them upon commencing their AGILE Lifetime Income, based on information entered and the date of Investment.
                </Typography>
              </Box>

              {/* Main Container */}
              <RateLookupTool resetTrigger={resetTrigger} />
            </Container>
          )}
        </Box>

        {/* Pre-footer Links */}
        <PreFooterLinks />

        {/* Footer */}
        <Footer />
      </Box>
    </>
  );
}

export default App;
